import { host } from '../../../config';
import { getHeaders, getNonJsonHeaders } from '../../../core/api';

export function fetchAgency() {
  return fetch(`${host}/api/agency/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function patchAgency(id, payload) {
  return fetch(`${host}/api/agency/${id}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function fetchInviteAgent(payload) {
  return fetch(`${host}/api/invite/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function uploadAgencyImage(id, acceptedFiles) {
  const formData = new FormData();
  formData.append('logo', acceptedFiles[0]);
  return fetch(`${host}/api/agency/${id}/`, {
    method: 'PATCH',
    headers: getNonJsonHeaders(),
    body: formData,
  });
}



// WEBPACK FOOTER //
// src/routes/agency/modules/api.js